import WalletTotalBalanceTile from './WalletTotalBalanceTile';

export default WalletTotalBalanceTile;